// Backend Unit.Category values — must match exactly. Used by UnitSelector.
export const UNIT_CATEGORY = Object.freeze({
  AREA: 'Area',
  CONCENTRATION: 'Concentration',
  WEIGHT: 'Weight',
  VOLUME: 'Volume',
  DOSAGE: 'Dosage',
  EXPOSURE: 'Exposure',
  MOLECULAR_WEIGHT: 'Molecular Weight',
});
